<div class="ui-g card event-details">
  <div class="ui-g-9 ui-md-12 ui-lg-9 ui-g-12 event-details-2">
    <form [formGroup]="formEditEvent">
      <div class="ui-g">
        <div class="ui-md-3 ui-sm-6"><span>Engagement Key</span></div>
        <div class="ui-md-3 ui-sm-6">
          {{ formEditEvent.controls['eventRegistrationId'].value }}
        </div>
        <div class="ui-md-3 ui-sm-6"><span>Status</span></div>
        <div class="ui-md-3 ui-sm-6">
          {{ formEditEvent.controls['eventStatus'].value }}
        </div>
      </div>
      <div class="ui-g">
        @if (!isMRPPProgram) {
          <div class="ui-md-3 ui-sm-6">
            <span>Request ID</span>
          </div>
          <div class="ui-md-3 ui-sm-6">
            {{ formEditEvent.controls['eventRegistrationBatchId'].value }}
          </div>
        }
        <div class="ui-md-3 ui-sm-6"><span>Request Date</span></div>
        <div class="ui-md-3 ui-sm-6">
          {{ formEditEvent.controls['requestDate'].value }}
        </div>
        @if (isMRPPProgram && !isOneToMany) {
          <div class="ui-md-3 ui-sm-6">
            <span>PMO Tenant Name</span>
          </div>
          <div class="ui-md-3 ui-sm-6">
            {{ formEditEvent.controls['tpName'].value }}
          </div>
        }
        @if (isMRPPProgram && isOneToMany) {
          <div class="ui-md-3 ui-sm-6">
            <span>Next Steps</span>
          </div>
          <div class="ui-md-3 ui-sm-6">
            {{ formEditEvent.controls['pmonextStepName'].value }}
          </div>
        }
      </div>
      <div class="ui-g">
        <div class="ui-md-3 ui-sm-6"><span>Engagement Name</span></div>
        @if (!isMRPPProgram) {
          <div class="ui-md-3 ui-sm-6">
            {{ formEditEvent.controls['eventName'].value }}
          </div>
        }
        @if (isMRPPProgram) {
          <div class="ui-md-3 ui-sm-6">Meeting Room Partner Program</div>
        }
        @if (isMRPPProgram && !isOneToMany) {
          <div class="ui-md-3 ui-sm-6">
            <span>Next Steps</span>
          </div>
          <div class="ui-md-3 ui-sm-6">
            {{ formEditEvent.controls['pmonextStepName'].value }}
          </div>
        }
      </div>
      <div class="ui-g">
        <div class="ui-md-3 ui-sm-6"><span>PMO Partner Name</span></div>
        <div class="ui-md-3 ui-sm-6">
          {{ formEditEvent.controls['partnerName'].value }}
        </div>
      </div>
      <div class="ui-g">
        @if (!isMRPPProgram) {
          <div class="ui-g" class="ui-md-3 ui-sm-6">
            <span>Task Owner</span>
          </div>
          <div class="ui-g" class="ui-md-3 ui-sm-6">
            {{ formEditEvent.controls['taskOwner'].value }}
          </div>
        }

        @if (isMRPPProgram) {
          <div class="ui-md-3 ui-sm-6">
            <span>Engagement Type</span>
          </div>
          <div class="ui-md-3 ui-sm-6">
            {{ formEditEvent.controls['eventName'].value }}
          </div>
        }
      </div>
    </form>
  </div>
  <div class="ui-g-3 ui-md-3 ui-sm-12">
    <div class="livemsg">
      <p-scrollPanel [style]="{ width: '100%', height: '90px' }">
        <table>
          <tr *ngFor="let item of notes">
            <td>
              <span class="msgname">{{ item.userAlias }}</span
              ><span class="msgdate">
                {{ item.createdDate | date: 'short' : 'UTC-8' }}(PST)</span
              ><br /><span class="msgcontent">{{ item.notes }}</span>
            </td>
          </tr>
        </table>
      </p-scrollPanel>
      <form [formGroup]="formNotes" (ngSubmit)="onSubmitNotes()">
        <textarea
          pTextarea
          [rows]="2"
          pInputTextarea
          placeholder="Min 3 characters"
          minlength="3"
          maxlength="400"
          formControlName="notes"></textarea>
        <div style="position: relative; top: 4px">
          <button
            type="submit"
            tooltipPosition="bottom"
            pTooltip="Send"
            class="btnmsg">
            <i class="fa fa-paper-plane" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            tooltipPosition="bottom"
            pTooltip="Refresh"
            class="btnmsg">
            <i
              class="fa fa-refresh"
              (click)="refreshNotes()"
              aria-hidden="true"></i>
          </button>
          @if (release === 'Prod') {
            <a
              target="_blank"
              href="https://msit.powerbi.com/groups/bb67cbd8-99ea-4206-8501-7536c68201a7/reports/94a5287e-f98e-4494-8a7d-7c8bc1fbb0f2/ReportSection93188d28fe904944dd33?filter=Master_Engagement/EngagementKey eq '{{
                eventRegistrationId
              }}'"
              tooltipPosition="bottom"
              pTooltip="History"
              class="fa fa-history icohistory"
              aria-hidden="true">
            </a>
          }
          @if (release !== 'Prod') {
            <a
              target="_blank"
              href="https://msit.powerbi.com/groups/b7cf08d2-8c22-4aa9-9a79-f4a8cd991f77/reports/1c164c70-828c-401d-b87a-2c075eab2888/ReportSection93188d28fe904944dd33?filter=Master_Engagement/EngagementKey eq '{{
                eventRegistrationId
              }}'"
              tooltipPosition="bottom"
              pTooltip="History"
              class="fa fa-history icohistory"
              aria-hidden="true">
            </a>
          }
        </div>
      </form>
    </div>
  </div>
</div>
